import addUniques from './addUniques'
import def from './def'
import func from './func'
import has from './has'
import mixinToString from './mixinToString'
import provide from './provide'
import type from './type'

export default {addUniques,def,func,has,mixinToString,provide,type}